//Catagories
import maleapparelCatag from '../images/catagories/hunter-bryant-unsplash.jpg'
import femaleapparelCatag from '../images/catagories/clem-onojeghuo-unsplash.jpg'
import footwearCatag from '../images/catagories/malik-skydsgaard-unsplash.jpg'
import watchesCatag from '../images/catagories/onur-binay-unsplash.jpg'
import essentialsCatag from '../images/catagories/laura-chouette-unsplash.jpg'
import nutritionCatag from '../images/catagories/towfiqu-barbhuiya-unsplash.jpg'

//Male apparel
import ma1 from '../images/items/male-apparel/211329_001_LF_Sherpa_3in_Split_Short_720x.jpg'
import ma2 from '../images/items/male-apparel/211333_644_LF_Sherpa_7in_2in1_Short_720x.jpg'
import ma3 from '../images/items/male-apparel/sxsp01l-gra_1form_f_sp22_x1450_9b666f0c-1788-4912-857a-354e6555a87d_720x.jpg'
import ma4 from '../images/items/male-apparel/211455_644_LF_Atmosphere_Short_Sleeve_2_720x.jpg'

//Female apparel
import fa1 from '../images/items/female-apparel/221523_633_LF_Method_5in_Short_Tight_720x.jpg'
import fa2 from '../images/items/female-apparel/ws01207pkw_40_720x.jpg'
import fa3 from '../images/items/female-apparel/221605_620_LF_Sprint_Free_Tank_2_720x.jpg'
import fa4 from '../images/items/female-apparel/221501_001_LF_Momentum_Thermal_Tight_720x.jpg'

//Footwear
import fw1 from '../images/items/footwear/AL0A7R6M_220_R_HERO_720x.jpg'
import fw2 from '../images/items/footwear/AURORA_FJ3889-100_PHSRH000-2000_720x.jpg'
import fw3 from '../images/items/footwear/1127896-BWHT_1_1_720x.jpg'
import fw4 from '../images/items/footwear/1127894-ICYC_1_720x.jpg'

//Watches
import w1 from '../images/items/watches/010-02064-01_Tundra_A_720x.jpg'
import w2 from '../images/items/watches/cf-lg-b0422365-46da-4622-946b-47fd02eedf28_720x.jpg'
import w3 from '../images/items/watches/Screenshot2023-03-30at11.24.21AM_720x.jpg'
import w4 from '../images/items/watches/ScreenShot2022-06-06at3.10.45PM_720x.jpg'

//Essentials
import e1 from '../images/items/essentials/The-Run-Calf-Sleeves-4.0-black-women-1_720x.jpg'
import e2 from '../images/items/essentials/TheRunCalf4.0-white-men-1_720x.jpg'
import e3 from '../images/items/essentials/280490_172_D2_Ghost_Lite_Crew_2_Pack_720x.jpg'
import e4 from '../images/items/essentials/DC3598-010-PHSFH001_1800x1800.jpg'

//Nutrition
import n1 from '../images/items/nutrition/GUEnergyGelSingle-RaspberryLemonade-medium_1_png_720x.jpg'
import n2 from '../images/items/nutrition/XACTPROTEINWaferBanoffee_720x.jpg'
import n3 from '../images/items/nutrition/NUUN-1200988_OrangeCitrus_A_1800x1800.jpg'
import n4 from '../images/items/nutrition/mint-brownie-18ct-395830_1296x_d57936cd-ae17-4919-ad7f-5fc2e0bc12dc_720x.jpg'

export const catagory = [
    { title: "Men's Apparel", image: maleapparelCatag, key: "male-apparel" },
    { title: "Women's Apparel", image: femaleapparelCatag, key: "female-apparel" },
    { title: "Footwear", image: footwearCatag, key: "footwear" },
    { title: "Watches", image: watchesCatag, key: "watches" },
    { title: "Essentials", image: essentialsCatag, key: "essentials" },
    { title: "Nutrition", image: nutritionCatag, key: "nutrition" }
];

export const maleApparel = [
    { name: 'Men\'s Brooks Sherpa 3" Split Short', image: ma1, price: 54.00, key: 'ma1', },
    { name: 'Men\'s Brooks Sherpa 7" 2-in-1 Short ', image: ma2, price: 68.00, key: 'ma2', },
    { name: 'SAXX Hightail 5" 2N1 Short', image: ma3, price: 68.00, key: 'ma3', },
    { name: 'Men\'s Brooks Atmosphere Short Sleeve 2.0', image: ma4, price: 48.00, key: 'ma4', }
];

export const femaleApparel = [
    { name: 'Women\'s Brooks Method 5" Short Tight', image: fa1, price: 54.00, key: 'fa1', },
    { name: 'Women\'s New Balance Accelerate Short 2.5 inch', image: fa2, price: 35.00, key: 'fa2', },
    { name: 'Women\'s Brooks Sprint Free Tank 2.0', image: fa3, price: 42.00, key: 'fa3', },
    { name: 'Women\'s Brooks Momentum Thermal Tight', image: fa4, price: 95.00, key: 'fa4', }
];

export const footwear = [
    { name: 'Men\'s Altra Escalante 3', image: fw1, price: 140.00, key: 'fw1', },
    { name: 'Men\'s Nike Invincible 3', image: fw2, price: 180.00, key: 'fw2', },
    { name: 'Women\'s HOKA Clifton 9', image: fw3, price: 145.00, key: 'fw3', },
    { name: 'Women\'s HOKA Mach 5', image: fw4, price: 140.00, key: 'fw4', }
];

export const watches = [
    { name: 'Garmin International Instinct', image: w1, price: 299.99, key: 'w1', },
    { name: 'Garmin Venu 2 Plus', image: w2, price: 449.99, key: 'w2', },
    { name: 'Garmin Forerunner 265', image: w3, price: 449.99, key: 'w3', },
    { name: 'Garmin Forerunner 255S', image: w4, price: 349.99, key: 'w4', }
];

export const essentials = [
    { name: 'Women\'s CEP Calf Sleeve 4.0', image: e1, price: 44.95, key: 'e1', },
    { name: 'Men\'s CEP Compression Calf Sleeve 4.0', image: e2, price: 40.00, key: 'e2', },
    { name: 'Brooks Ghost Lite Crew 2-Pack', image: e3, price: 24.00, key: 'e3', },
    { name: 'Nike Dri-Fit Aerobill Featherlight Perforated Running Cap', image: e4, price: 30.00, key: 'e4', }
];

export const nutrition = [
    { name: 'GU Raspberry Lemonade Energy Gel', image: n1, price: 1.50, key: 'n1', },
    { name: 'XACT Banoffee Pie Protein Bar', image: n2, price: 2.95, key: 'n2', },
    { name: 'Nuun Orange Citrus Immune Support Tablets NUUN', image: n3, price: 7.00, key: 'n3', },
    { name: 'Built Bar Mint Brownie', image: n4, price: 2.50, key: 'n4', }
];